<template>
	<v-container id="customers-page-overview">
		<v-row>
			<v-col cols="12" class="text size-large weight-bold font-alt">
				Tableau de bord
			</v-col>
		</v-row>
		<v-row class="px-3 mt-8">
			<v-col cols="12" class="colored-bg">
				<v-row class="pa-3">
					<v-col cols="12">
						<div class="text size-medium color-black-base">Évolution des consomations SMS/Email</div>
					</v-col>
					<v-col cols="12">
						<v-row>
							<v-col 
								lg="9"
								sm="12"
								md="12"
							>
								<div>
									<v-card class="theme-card pt-11 pb-7 px-10">
										<!-- <input @change="updateCustomerInChart()" type="number" min="2020" :max="new Date().getFullYear()" step="1" v-model="selectedYear" /> -->
										<chart-line :collection="smsHistory" collection-label="created_at" collection-value="value" color="purple" ref="chartLine"/>
									</v-card>
								</div>
								<!-- <v-row>
									<kpi-trend class="col-4" v-for="(card, index) in kpiTrends" :key="index"
										:class="{
											'mb-4' : $vuetify.breakpoint.md, 
											'mb-4' : index > 0 && !$vuetify.breakpoint.md,
											'mb-4' : index < 2 && $vuetify.breakpoint.md
										}"
										:label="card.label"
										:color="card.color"
										:trend="card.trend"
										:icon="card.icon"
										:value="card.value"
									/>
								</v-row> -->
							</v-col>
							<v-col 
								lg="3"
								md="12"
								:class="{
									'd-flex justify-space-between': $vuetify.breakpoint.md 
								}" 
							>
								<div class="ctn__card-items-count">
									<div>
										<CardItemCount
											:label="'Sms restants'"
											:hint="'sms'"
											:value="manager.sms_amount"
										></CardItemCount>
									</div>
								</div>
							</v-col>
						</v-row>

						<v-row>
							<v-col 
								lg="9"
								sm="12"
								md="12"
							>
								<div>
									<v-card class="theme-card pt-11 pb-7 px-10">
										<!-- <input @change="updateCustomerInChart()" type="number" min="2020" :max="new Date().getFullYear()" step="1" v-model="selectedYear" /> -->
										<chart-line :collection="emailHistory" collection-label="created_at" collection-value="value" color="purple" ref="chartLine"/>
									</v-card>
								</div>
								<!-- <v-row>
									<kpi-trend class="col-4" v-for="(card, index) in kpiTrends" :key="index"
										:class="{
											'mb-4' : $vuetify.breakpoint.md, 
											'mb-4' : index > 0 && !$vuetify.breakpoint.md,
											'mb-4' : index < 2 && $vuetify.breakpoint.md
										}"
										:label="card.label"
										:color="card.color"
										:trend="card.trend"
										:icon="card.icon"
										:value="card.value"
									/>
								</v-row> -->
							</v-col>
							<v-col 
								lg="3"
								md="12"
								:class="{
									'd-flex justify-space-between': $vuetify.breakpoint.md 
								}" 
							>
								<div class="ctn__card-items-count">
									<div>
										<CardItemCount
											:label="'Emails restants'"
											:value="manager.email_amount"
											:hint="'email'"
										></CardItemCount>
									</div>
								</div>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12">
						<div class="text size-medium color-black-base">Segments de base</div>
					</v-col>
					<v-col cols="12">
						<v-row class="px-2">
							<v-col class="px-1" sm="4" md="2" v-for="(category, index) in categories" :key="index">
								<category-details
									:color="category.color"
									:label="category.label"
									:description="category.description"
								/>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12">
						<div class="text size-medium color-black-base">Derniers utilisateurs acquis</div>
					</v-col>
					<v-col cols="12">
						<div v-if="!dataLoaded">
							Loading ...
						</div>
						<table-users v-else />
					</v-col>
					<v-col cols="12" class="text-center">
						<v-btn @click="goToBaseClient()" class="theme-btn shape-rounded filled-purple glow drawer-button">En savoir plus</v-btn>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script type="text/javascript">

	import chartLine from '@/components/charts/chart-line'
	import kpiTrend from '@/components/cards/kpi-trend'
	import categoryDetails from '@/components/cards/category-details'
	import tableUsers from './table-users'
	import CardItemCount from '@/components/cards/dashboard/card-item-count.vue';

    export default {
        components: {
        	chartLine,
        	kpiTrend,
        	categoryDetails,
        	tableUsers,
			CardItemCount
        },
        data () {
            return {
				selectedYear: new Date().getFullYear(),
            }
        },
        computed : {
            kpiTrends () {
            	return this.$store.state.userOverview.kpiTrends;
            },
            optInHistory () {
            	return this.$store.state.userOverview.optInHistory;
            },
			smsHistory () {
            	const smsHistory = this.$store.state.userOverview.smsEmailHistory.filter((row) => row.type === "SMS");
				return smsHistory.map(row => ({
					...row,
					created_at: this.convertDateFormat(row.created_at)
				}))
            },
			emailHistory () {
            	const emailHistory = this.$store.state.userOverview.smsEmailHistory.filter((row) => row.type === "EMAIL");
				return emailHistory.map(row => ({
					...row,
					created_at: this.convertDateFormat(row.created_at)
				}))
            },
            categories () {
            	return this.$store.state.segments.list;
            },
			dataLoaded () {
				return this.$store.state.customer.dataLoaded;
			},
			manager() {
				return this.$store.state.auth.users.data;
			},
			customers () {
				return this.$store.state.customer.customers;
			},
        },
        async created () {
			await this.$store.dispatch('segments/getSegments');
			await this.$store.dispatch('customer/loadCustomerData').then(() => {
				this.updateSmsEmailHistory()
			})
			await this.$store.dispatch('dashboardV2/loadAnalytics', {
				success : () => {
					this.$store.commit('userOverview/setKpiTrends', {
						index : 0,
						value : this.$store.state.dashboardV2.analytics.data.kpi.nb_registration
					});
					this.$store.commit('userOverview/setKpiTrends', {
						index : 2,
						value : this.$store.state.dashboardV2.analytics.data.kpi.nb_registration
					});
				}
			});
        },
		async mounted() {
			await this.updateSmsEmailHistory()
		},
        methods : {
			convertDateFormat(isoString) {
				const date = new Date(isoString);
				const options = { 
					year: 'numeric', 
					month: '2-digit', 
					day: '2-digit', 
					hour: '2-digit', 
					minute: '2-digit', 
					second: '2-digit', 
					hour12: false 
				};
				const dateTimeFormat = new Intl.DateTimeFormat('en-US', options);
				const [{value: month},,{value: day},,{value: year},,{value: hour},,{value: minute},,{value: second}] = dateTimeFormat.formatToParts(date);

				return `${month}/${day}/${year} ${hour}:${minute}:${second}`;
			},
            goToBaseClient() {
				this.$router.push({ name: "CustomersDatabase", replace: true })
			},
			updateCustomerInChart() {
				this.$store.commit('userOverview/resetChart')
				if (!this.customers) return
				const customers = this.customers.filter((customer) => {
					const year = customer.created_at.split('/')[2]
					return year == this.selectedYear
				})
				for (const customer of customers) {
					const month = customer.created_at.split('/')[1] - 1
					this.$store.commit('userOverview/increaseMonthInChart', month)
				}
				this.$refs['chartLine'].makeChart()
			},
			async updateSmsEmailHistory() {
				await this.$store.dispatch('userOverview/getSmsEmailDashboard')
			}
        }
    }

</script>

<style lang="scss">
	.ctn__card-items-count {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 5rem;
		flex-direction: column;
	}
</style>